<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      class="text-center pt-10"
    >
      <span
        class="font-weight-bold primary--text header-sp"
        :class="{
          'header-desktop': $vuetify.breakpoint.lgAndUp,
          'header-desktop-md': $vuetify.breakpoint.md,
          'header-desktop-sm': $vuetify.breakpoint.sm
        }"
        v-text="$t('article.terms.text')"
      />
    </v-col>
    <v-col cols="12">
      <v-row
        no-gutters
        justify="center"
      >
        <v-col cols="10">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="mt-7"
            >
              <span
                class="text-body-2"
                v-text="$t('article.mainHeader.text1')"
              />
            </v-col>
            <v-col
              cols="12"
              class="mt-5"
            >
              <span
                class="text-body-2"
                v-text="$t('article.mainHeader.text2')"
              />
            </v-col>
            <v-col
              v-for="(article, index) in articles"
              :key="index"
              cols="12"
            >
              <Article
                class="mt-10"
                :data="article.article"
                :type="article.article.type"
              />
            </v-col>
            <v-col
              cols="12"
              class="my-10"
            >
              <span
                class="text-body-2"
                v-text="$t('article.date.text')"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Article from '@/components/Article'

export default {
  components: { Article },
  data () {
    return {
      //
    }
  },
  computed: {
    articles () {
      try {
        return [
          {
            article: {
              title: this.$t('article.article1.title'),
              info: [
                this.$t('article.article1.info1'),
                this.$t('article.article1.info2'),
                this.$t('article.article1.info3'),
                this.$t('article.article1.info4')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article2.title'),
              headerInfo: this.$t('article.article2.headerInfo'),
              info: [
                this.$t('article.article2.info1'),
                this.$t('article.article2.info2'),
                this.$t('article.article2.info3'),
                this.$t('article.article2.info4'),
                this.$t('article.article2.info5'),
                this.$t('article.article2.info6')
              ],
              list: [
                this.$t('article.article2.list1'),
                this.$t('article.article2.list2')
              ],
              listPosition: 5,
              type: 'letterList'
            }
          },
          {
            article: {
              title: this.$t('article.article3.title'),
              info: [
                this.$t('article.article3.info1'),
                this.$t('article.article3.info2'),
                this.$t('article.article3.info3'),
                this.$t('article.article3.info4')
              ],
              list: [
                this.$t('article.article3.list1'),
                this.$t('article.article3.list2'),
                this.$t('article.article3.list3'),
                this.$t('article.article3.list4'),
                this.$t('article.article3.list5'),
                this.$t('article.article3.list6'),
                this.$t('article.article3.list7'),
                this.$t('article.article3.list8')
              ],
              listPosition: 2,
              type: 'list'
            }
          },
          {
            article: {
              title: this.$t('article.article4.title'),
              info: [
                this.$t('article.article4.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article5.title'),
              info: [
                this.$t('article.article5.info1'),
                this.$t('article.article5.info2'),
                this.$t('article.article5.info3'),
                this.$t('article.article5.info4')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article6.title'),
              info: [
                this.$t('article.article6.info1'),
                this.$t('article.article6.info2')
              ],
              list: [
                this.$t('article.article6.list1'),
                this.$t('article.article6.list2'),
                this.$t('article.article6.list3'),
                this.$t('article.article6.list4'),
                this.$t('article.article6.list5'),
                this.$t('article.article6.list6'),
                this.$t('article.article6.list7'),
                this.$t('article.article6.list8'),
                this.$t('article.article6.list9'),
                this.$t('article.article6.list10'),
                this.$t('article.article6.list11'),
                this.$t('article.article6.list12'),
                this.$t('article.article6.list13'),
                this.$t('article.article6.list14'),
                this.$t('article.article6.list15'),
                this.$t('article.article6.list16'),
                this.$t('article.article6.list17'),
                this.$t('article.article6.list18')
              ],
              listPosition: 0,
              type: 'list'
            }
          },
          {
            article: {
              title: this.$t('article.article7.title'),
              info: [
                {
                  info: this.$t('article.article7.info1'),
                  list: [
                    {
                      listText: this.$t('article.article7.info1list1'),
                      details: [
                        this.$t('article.article7.list1detail1'),
                        this.$t('article.article7.list1detail2'),
                        this.$t('article.article7.list1detail3'),
                        this.$t('article.article7.list1detail4'),
                        this.$t('article.article7.list1detail5')
                      ]
                    },
                    {
                      listText: this.$t('article.article7.info1list2'),
                      details: [
                        this.$t('article.article7.list2detail1'),
                        this.$t('article.article7.list2detail2')
                      ]
                    }
                  ]
                },
                {
                  info: this.$t('article.article7.info2'),
                  list: []
                },
                {
                  info: this.$t('article.article7.info3'),
                  list: [
                    {
                      listText: this.$t('article.article7.info3list1'),
                      details: [
                        this.$t('article.article7.info3detail1'),
                        this.$t('article.article7.info3detail2'),
                        this.$t('article.article7.info3detail3')
                      ]
                    },
                    {
                      listText: this.$t('article.article7.info3list2'),
                      details: []
                    }
                  ]
                }
              ],
              type: 'mixed'
            }
          },
          {
            article: {
              title: this.$t('article.article8.title'),
              info: [
                this.$t('article.article8.info1'),
                this.$t('article.article8.info2'),
                this.$t('article.article8.info3')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article9.title'),
              headerInfo: this.$t('article.article9.headerInfo'),
              info: [
                this.$t('article.article9.info1'),
                this.$t('article.article9.info2'),
                this.$t('article.article9.info3'),
                this.$t('article.article9.info4')
              ],
              type: 'numberedList'
            }
          },
          {
            article: {
              title: this.$t('article.article10.title'),
              info: [
                this.$t('article.article10.info1'),
                this.$t('article.article10.info2'),
                this.$t('article.article10.info3'),
                this.$t('article.article10.info4'),
                this.$t('article.article10.info5')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article11.title'),
              headerInfo: this.$t('article.article11.headerInfo'),
              info: [
                this.$t('article.article11.info1'),
                this.$t('article.article11.info2'),
                this.$t('article.article11.info3')
              ],
              type: 'numberedList'
            }
          },
          {
            article: {
              title: this.$t('article.article12.title'),
              info: [
                this.$t('article.article12.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article13.title'),
              info: [
                this.$t('article.article13.info1'),
                this.$t('article.article13.info2')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article14.title'),
              info: [
                this.$t('article.article14.info1'),
                this.$t('article.article14.info2'),
                this.$t('article.article14.info3'),
                this.$t('article.article14.info4')
              ],
              list: [
                this.$t('article.article14.list1'),
                this.$t('article.article14.list2'),
                this.$t('article.article14.list3'),
                this.$t('article.article14.list4'),
                this.$t('article.article14.list5'),
                this.$t('article.article14.list6'),
                this.$t('article.article14.list7'),
                this.$t('article.article14.list8'),
                this.$t('article.article14.list9'),
                this.$t('article.article14.list10')
              ],
              listPosition: 2,
              type: 'list'
            }
          },
          {
            article: {
              title: this.$t('article.article15.title'),
              info: [
                this.$t('article.article15.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article16.title'),
              info: [
                this.$t('article.article16.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article17.title'),
              info: [
                this.$t('article.article17.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article18.title'),
              info: [
                this.$t('article.article18.info1'),
                this.$t('article.article18.info2')
              ],
              type: 'numbered'
            }
          },
          {
            article: {
              title: this.$t('article.article19.title'),
              info: [
                this.$t('article.article19.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article20.title'),
              info: [
                this.$t('article.article20.info1'),
                this.$t('article.article20.info2')
              ],
              list: [
                this.$t('article.article20.list1'),
                this.$t('article.article20.list2'),
                this.$t('article.article20.list3'),
                this.$t('article.article20.list4')
              ],
              listPosition: 0,
              type: 'list'
            }
          },
          {
            article: {
              title: this.$t('article.article21.title'),
              info: [
                this.$t('article.article21.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article22.title'),
              info: [
                this.$t('article.article22.info1')
              ],
              type: 'default'
            }
          },
          {
            article: {
              title: this.$t('article.article23.title'),
              info: [
                this.$t('article.article23.info1'),
                this.$t('article.article23.info2')
              ],
              type: 'numbered'
            }
          }
        ]
      } catch (error) {
        return []
      }
    }
  }
}
</script>

<style scoped>
.header-sp {
  font-size: 18px;
}
.header-desktop {
  font-size: 40px;
}
.header-desktop-md {
  font-size: 32px;
}
.header-desktop-sm {
  font-size: 24px;
}
</style>
